import {useMemo} from "react";
import {ReachAccountSearchResult} from "../../apis/requests/accounts/searchAccounts";
import {useGetTriggerAccountPayload} from "../../apis/requests/triggers/getTriggerAccountPayload";
import {useGetTriggerSchema} from "../../apis/requests/triggers/getTriggerSchema";
import {TriggerInteractionType} from "../../apis/requests/triggers/types";
import {examplePayload} from "./helpers";

export const useExamplePayload = (
  interactionType: TriggerInteractionType,
  account: ReachAccountSearchResult | null
) => {
  const {data: schema} = useGetTriggerSchema();
  const {data: accountPayload, isFetched} = useGetTriggerAccountPayload(
    {interactionType, accountId: account?.account_id ?? 0},
    {enabled: !!account}
  );
  const accountFields = account ? accountPayload?.data : undefined;
  const example = useMemo(() => {
    const parameters = schema?.interaction_types.find((t) => t.interaction_type === interactionType)?.parameters;
    return parameters ? {...examplePayload(parameters), ...accountFields} : null;
  }, [schema, interactionType, accountFields]);

  return {example, accountFields, ready: !account || isFetched};
};
